export const AppRoutes = {
    HOME_PAGE: '/',
    SUPPLIER_FORM_PAGE: '/supplier/',
    NEW_CUSTOMER_PAGE: '/new-customer/',
    LOGIN_PAGE: '/login',
};
